// frontend/src/store/modules/funnelWebWx.js
import api from '@/api'
import sharedFunnelWebModule, { setApiGetter } from '@shared-library/store/modules/funnelWeb.js'

// 设置 API getter
setApiGetter(() => api);

// 扩展共享的store模块
const sharedModule = sharedFunnelWebModule;

// 扩展state
const extendedState = {
  ...sharedModule.state,
  // 添加微信端特定的状态
}

// 扩展getters
const extendedGetters = {
  ...sharedModule.getters,
  // 添加微信端特定的getters
}

// 扩展actions
const extendedActions = {
  ...sharedModule.actions,
  // 添加微信端特定的actions
}

// 扩展mutations
const extendedMutations = {
  ...sharedModule.mutations,
  // 添加微信端特定的mutations
}

export default {
  namespaced: true,
  state: extendedState,
  getters: extendedGetters,
  actions: extendedActions,
  mutations: extendedMutations
}